<template>
  <div>
    <div class="chart-title">
      <div>翌日のスポット価格</div>
      <div>(システムプライス・エリアプライス)</div>
    </div>

    <div class="chart-container">
      <div class="chart-container__header">
        <span class="chart-container__header-label"
          >{{ dateLabel }}受渡分のJEPXスポット取引価格</span
        >
        <button
          class="chart-container__header-btn commonButton t-chartaccent"
          @click="isOpenCalendar = true"
        >
          日時を選択する
        </button>
        <div v-if="isOpenCalendar" class="calendar">
          <DatePicker
            v-model="baseDate"
            :available-dates="availableDates"
            @input="isOpenCalendar = false"
          ></DatePicker>
        </div>
      </div>
      <div class="chart-container__action-btn-list">
        <ul>
          <li>
            <button
              :class="{ 'not-select-btn': disabledNormal }"
              @click="callOverviewChart('normal')"
            >
              NORMAL
            </button>
          </li>
          <li>
            <button
              :class="{ 'not-select-btn': disabledAverage }"
              @click="callOverviewChart('average')"
            >
              AVERAGE
            </button>
          </li>
        </ul>
        <ul>
          <li>
            <button :class="{ 'not-select-btn': disabledDay }" @click="changeDay">DAY</button>
          </li>
          <li>
            <button :class="{ 'not-select-btn': disabledWeek }" @click="changeWeek">WEEK</button>
          </li>
          <li>
            <button :class="{ 'not-select-btn': disabledMonth }" @click="changeMonth">MONTH</button>
          </li>
        </ul>
      </div>
      <!-- チャート -->
      <div v-if="showErrorText" class="errorText">
        データの取得に失敗しました。時間を置いて再度お試しください。
      </div>
      <div v-if="!showErrorText" id="overview-chart" class="jepx-price-checker"></div>
      <!-- フッター -->
      <div class="chart-container__footer">
        <p>デフォルトでは、最新の１日分を表示しています。</p>
        <p>エリアプライスは数値が重複し、線が重なって見えることがあります。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { setOverviewChart } from '../../functions/drawJepxChart'
import dayjs from 'dayjs'
import Vue from 'vue'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
Vue.component('date-picker', DatePicker)

const CONST_VALUES = {
  normal: 'normal',
  average: 'average',
  day: 'day',
  week: 'week',
  month: 'month',
}

export default {
  name: 'JepxOverviewChart',
  components: {
    DatePicker,
  },
  data() {
    return {
      baseDate: null,
      startDate: null,
      endDate: null,
      option: {
        chartType: CONST_VALUES.normal,
        dateType: CONST_VALUES.day,
      },
      availableDates: { start: new Date(2018, 3, 1), end: new Date() },
      isOpenCalendar: false,
      showErrorText: false,
    }
  },
  computed: {
    dateLabel() {
      if (this.baseDate === null) {
        return ''
      }
      if (this.option.dateType === CONST_VALUES.day) {
        return `${this.startDate.getFullYear()}年${
          this.startDate.getMonth() + 1
        }月${this.startDate.getDate()}日`
      } else if (this.option.dateType === CONST_VALUES.week) {
        return `${this.startDate.getFullYear()}年${
          this.startDate.getMonth() + 1
        }月${this.startDate.getDate()}日週`
      } else {
        return `${this.startDate.getFullYear()}年${this.startDate.getMonth() + 1}月`
      }
    },
    chartParams() {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        chartType: this.option.chartType,
      }
    },
    disabledNormal() {
      return this.option.chartType !== CONST_VALUES.normal
    },
    disabledAverage() {
      return this.option.chartType !== CONST_VALUES.average
    },
    disabledDay() {
      return this.option.dateType !== CONST_VALUES.day
    },
    disabledWeek() {
      return this.option.dateType !== CONST_VALUES.week
    },
    disabledMonth() {
      return this.option.dateType !== CONST_VALUES.month
    },
  },
  watch: {
    baseDate() {
      if (this.option.dateType === CONST_VALUES.day) {
        this.changeDay()
      } else if (this.option.dateType === CONST_VALUES.week) {
        this.changeWeek()
      } else {
        this.changeMonth()
      }
    },
    async startDate() {
      if (this.option.dateType === CONST_VALUES.day) {
        this.endDate = this.startDate
      }

      await setOverviewChart('#overview-chart', this.chartParams)
        .then(() => {
          this.showErrorText = false
        })
        .catch(() => {
          this.showErrorText = true
        })
    },
  },
  async mounted() {
    const nowDate = new Date()
    const defaultDate =
      nowDate.getHours() >= 12 ? dayjs(nowDate).add(1, CONST_VALUES.day).toDate() : nowDate

    this.availableDates.end = defaultDate
    this.baseDate = defaultDate
    this.startDate = defaultDate
    this.endDate = defaultDate

    document.addEventListener('click', this.checkClosePicker)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.checkClosePicker)
  },
  methods: {
    async callOverviewChart(chartType) {
      this.option.chartType = chartType

      await setOverviewChart('#overview-chart', this.chartParams)
        .then(() => {
          this.showErrorText = false
        })
        .catch(() => {
          this.showErrorText = true
        })
    },
    changeDay() {
      this.option.dateType = CONST_VALUES.day

      this.startDate = this.baseDate
      this.endDate = this.baseDate
    },
    changeWeek() {
      this.option.dateType = CONST_VALUES.week

      const baseDay = this.baseDate.getDay()
      const diffSun = baseDay
      const diffSat = 6 - diffSun

      this.startDate = dayjs(this.baseDate).subtract(diffSun, CONST_VALUES.day).toDate()
      this.endDate = dayjs(this.baseDate).add(diffSat, CONST_VALUES.day).toDate()
    },
    changeMonth() {
      this.option.dateType = CONST_VALUES.month

      this.startDate = new Date(this.baseDate.getFullYear(), this.baseDate.getMonth(), 1)
      this.endDate = new Date(this.baseDate.getFullYear(), this.baseDate.getMonth() + 1, 0)
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar()
    },
    checkClosePicker(e) {
      if (!e.target.closest('.chart-container__header-btn') && !e.target.closest('.calendar')) {
        this.isOpenCalendar = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.chart-title {
  font-size: 3.2rem;
  font-weight: bold;
  text-align: center;
}

.chart-container {
  padding: 2rem 1.5rem 3rem;
  margin-top: 3.2rem;
  background: black;

  .chart-container__header {
    padding: 1.4rem 1.8rem 1.1rem;
    background: #1e1e24;

    .chart-container__header-label {
      font-size: 2.2rem;
      font-weight: bold;
    }
    .chart-container__header-btn {
      display: block;
      min-width: 2rem;
      padding: 0.2rem 0.8rem;
      margin-top: 0.4rem;
      color: #000000;
      background: #f3f3f3;
      border: none;
    }
  }

  .calendar {
    position: absolute;
    z-index: 99;
  }

  &__action-btn-list {
    width: 1.2rem;
    margin-top: 2rem;

    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      list-style-type: none;

      button {
        font-style: italic;
        font-weight: bold;
        color: white;
        cursor: pointer;

        background-color: transparent;
        border: none;
        outline: none;
      }
    }
  }

  .chart-container__footer {
    margin-top: 1rem;
    font-size: 1.2rem;
    text-align: center;
  }
}

.not-select-btn {
  color: #6c6c6c !important;
}

#overview-chart {
  margin-top: 2rem;
}

@media screen and (max-width: 960px) {
  .chart-title {
    font-size: 1.6rem;
  }

  .chart-container__header-label {
    font-size: 1.6rem !important;
  }
}

.errorText {
  padding: 15rem;
  font-size: 1.6rem;
  text-align: center;
}
</style>
